import { inject, Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { tap } from 'rxjs';

import { ENVIRONMENT } from '@core/common-legacy';
import { FeatureCode } from '@core/feature-spec-types';
import { HttpApiService } from '@core/http-legacy';

import type { FeatureSpecFetchResponse } from './feature-spec.types';

const validateResponse = (data: any, printToConsole: boolean) => {
  if (!data.features || !Array.isArray(data.features)) {
    throw new Error('Invalid response');
  }
  const { features } = data;
  const responseKeys: string[] = features.map((feature: any) => feature.codename);
  Object.values(FeatureCode).forEach((key: string) => {
    if (!responseKeys.includes(key) && printToConsole) {
      console.warn(`Feature ${key} is missing in the response`);
    }
  });

  return data;
};

@Injectable({ providedIn: 'root' })
export class FeatureSpecHttpClient {
  protected readonly httpApi = inject(HttpApiService);

  private environment = inject(ENVIRONMENT, { optional: true });

  public fetch(): Observable<FeatureSpecFetchResponse> {
    return this.httpApi
      .get('/features/spec')
      .pipe(
        tap(response =>
          validateResponse(response, this.environment?.environmentName !== 'production'),
        ),
      );
  }
}
